import React from 'react';
import { IProduct } from '@/interfaces/product';
import { DetailItem } from '@/components/dataItem/data-view-item';
import { EditFilled } from '@ant-design/icons';
import Title from '@/components/title';
import { Button } from 'antd';
import { formatNumber } from '@/utils/dataUtils';
import { isFullAccess } from '@/utils/permissionUtils';

interface IProps {
  data: IProduct;
  onEdit: () => void;
}

const ProductViewInfo = ({ data, onEdit }: IProps) => {
  const perFullAccess = isFullAccess();
  return (
    <>
      <Title
        customClassName="text-lg text-blue-700"
        customContainerClassName="py-0"
        title={`รายละเอียด`}
      >
        <div className="flex flex-row gap-2">
          {perFullAccess && (
            <Button type="primary" onClick={() => onEdit()}>
              <EditFilled />
              แก้ไข
            </Button>
          )}
        </div>
      </Title>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 w-full gap-3 mt-5">
        <DetailItem label="รหัส" detail={data?.code} />
        <DetailItem label="ชื่อ" detail={data?.name} />
        <DetailItem label="หน่วย Package" detail={data?.packageUnitName} />
        <DetailItem label="หน่วยขาย" detail={data?.baseUnitName} />
        <DetailItem
          label="Conversion"
          detail={formatNumber(data?.conversion)}
        />
        <DetailItem
          label={data?.iSample ? `ต้นทุน` : `ราคาขาย`}
          detail={formatNumber(data?.unitPrice)}
        />
        <DetailItem
          label="Safety Stock"
          detail={formatNumber(Number(data?.safetyStock))}
        />
        <DetailItem label="BU" detail={data?.businessUnitName} />
      </div>
      <div className="flex gap-3">
        <DetailItem label="หมายเหตุ" detail={data?.remark} />
      </div>
    </>
  );
};

export default ProductViewInfo;
